<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Medição
            <Modal
              :tipoSelecao="'ferramentaria'"
              :desativarDevolucao="true"
              :desativarRetirada="true"
              :desativarSolicitante="true"
              :desativarDocumentoEntrada="true"
              :desativarDocumentoSaida="true"
              :desativarUnidade="true"
              :desativarNumero="true"
              :desativarPatrimonio="true"
              :desativarFornecedor="true"
              :desativarTipoMovimento="true"
              :desativarCentro="true"
              :desativarTempo="true"
              :desativarNtransferencia="true"
              :desativarDescricao="true"
              :desativarCodigo="true"
              :desativarGrupo="true"
              :desativarSubGrupo="true"
              :desativarStatus="true"
              @unidade="getAtivos"
              :desativarOrigem="true"
              :loadingValue="loadingValue"
              :dataDisable="true"
              :classFornecedorSelect="'col-11'"
              :classDataEntrada="'col-6'"
              :classDataSaida="'col-5'"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :exportName="'Medição'"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'ferramentaria-relatorio-medicao'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
    <q-dialog v-model="showComentarioMovimentacao">
      <q-card style="height: 220px; width: 450px">
        <q-card-section class="column">
          <span style="color: #21324a" class="mensagem-text">Aviso</span>
          <q-separator style="height: 1px; background-color: #21324a" />
        </q-card-section>

        <q-card-section style="min-height: 70px">
          <span style="color: #21324a">
            Seu relatório excedeu o tempo para geração automático, aguarde o
            link na central de notificações pra download do relatório
            completo.</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Confirmar"
            :disabled="desabilitarConfirme"
            no-caps
            icon="done"
            v-close-popup
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Modal from "../components/ModalFerramentaria.vue";
import Flexmonster from "../../relatorios/components/Flexmonster.vue";
export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const types = ref({
      Codigo: {
        type: "string",
      },
      Patrimonio: {
        type: "string",
      },
      "Data Entrada": {
        type: "date string",
      },
      "Data Saida": {
        type: "date string",
      },
      "Documento Transferencia Entrada": {
        type: "string",
      },
      "Status Transferencia Saida": {
        type: "string",
      },
      "Documento Transferencia Saida": {
        type: "string",
      },
      "Numero Transferencia Saida": {
        type: "string",
      },
      "Numero Transferencia Entrada": {
        type: "string",
      },
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const showComentarioMovimentacao = ref(false);

    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const filtrosObject = ref(null);
    const showGrandTotals = ref("");
    const formats = ref([
      {
        name: "currencyFormat",
        currencySymbol: "R$ ",
        currencySymbolAlign: "left",
        thousandsSeparator: ".",
        decimalSeparator: ",",
        decimalPlaces: 2,
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});

    const getAtivos = async (data, value) => {
      try {
        filtrosObject.value = {
          dataInicial:
            value?.dataEntrada != ""
              ? value?.dataEntrada.split("/").reverse().join("-")
              : undefined,
          dataFinal:
            value?.dataSaida != ""
              ? value?.dataSaida.split("/").reverse().join("-")
              : undefined,
          fornecedor:
            value?.fornecedorSelect == ""
              ? undefined
              : value?.fornecedorSelect?.parceiroId,
        };

        loadingValue.value = true;
        const response = await store.dispatch(
          "ferramentaria/relatorioMedicao",
          {
            dataInicial:
              value?.dataEntrada != ""
                ? value?.dataEntrada.split("/").reverse().join("-")
                : undefined,
            dataFinal:
              value?.dataSaida != ""
                ? value?.dataSaida.split("/").reverse().join("-")
                : undefined,
            fornecedor:
              value?.fornecedorSelect == ""
                ? undefined
                : value?.fornecedorSelect?.parceiroId,
          }
        );

        link.value = response.data.resultado.dados;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject.value);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        loadingValue.value = false;
        if (error?.response?.status == undefined) {
          showComentarioMovimentacao.value = !showComentarioMovimentacao.value;
          getRelatorioSecundario();
        }
      }
    };

    const getRelatorioSecundario = async () => {
      loadingValue.value = true;

      const response = await store.dispatch("ferramentaria/relatorioMedicao", {
        dataInicial: filtrosObject.value?.dataInicial,
        dataFinal: filtrosObject.value?.dataFinal,
        fornecedor: filtrosObject.value?.fornecedor,
        background: 1,
      });

      link.value = response.data.resultado.dados;
      updateLink.value++;
      loadingValue.value = false;
      exibir.value = true;
      url.value = response?.request?.responseURL;
    };
    const relatorioLink = route.query.id;
    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        relatorioLink != "" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.resultado.dados;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getAtivos,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtros,
      showTotals,
      id,
      getRelatorioSalvo,
      formats,
      loadingStop,
      verificarUrl,
      url,
      showComentarioMovimentacao,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
    };
  },
};
</script>

<style scoped>
.mensagem-text {
  font-weight: bold;
  font-size: 18px;
}
</style>
